import styled from 'styled-components'

export const WhatsAppTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  flex-wrap: wrap;

  h2,
  h3 {
    width: 100%;
    text-align: center;
  }

  h2 {
    font-weight: 400;
    font-size: 18px;
    font-style: normal;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 16px;
    }

    h3 {
      font-size: 15px;
    }
  }
`

export const WhatsAppWrapper = styled.a`
  display: flex;
  margin: 1.5rem 0;
  background: #24d366;
  color: #fff;
  overflow: hidden;
  border-radius: 20px;
  align-items: center;

  svg {
    width: 100px;
    height: 100px;
  }
`

export const WhatsAppButtonText = styled.div`
  display: flex;
  align-items: center;
  padding-left: 25px;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  line-height: 20px;
`
